import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { NotFoundModalComponent } from "@modules/main/components/not-found-modal/not-found-modal.component";
import { Web3AutoMigrationIntroComponentComponent } from "@modules/web3/components/web3-auto-migration-intro/web3-auto-migration-intro.component.component";
import { migrationIntroGuard } from "@modules/web3/guards/migration-intro.guard";
import { Web3AutoMigrationMergeComponentComponent } from "./components/web3-auto-migration-merge/web3-auto-migration-merge.component.component";
import { Web3AutoMigrateSuccessComponent } from "./components/web3-auto-migrate-success/web3-auto-migrate-success.component";
import { migrationSuccessGuard } from "./guards/migration-success.guard";
import { web3VisionGuardFn } from "./guards/web3-vision.guard";

export enum Web3MigrationRoutes {
	basePath = "web3-migration",
	autoMigrationIntro = "auto-migration-intro",
	autoMigrationSignup = "auto-migration-signup",
	autoMigrationSuccess = "auto-migration-success",
	autoMigrationCutOff = "auto-migration",
	notFound = "notfound"
}

const routes: Routes = [
	{
		component: ModalHolderComponent,
		path: Web3MigrationRoutes.autoMigrationIntro,
		canActivate: [migrationIntroGuard],
		data: {
			component: Web3AutoMigrationIntroComponentComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: true,
				headerTitleKey: "web3",
				cancelKey: "close",
				size: ModalSizes.lg,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: false
			}
		}
	},
	{
		component: ModalHolderComponent,
		path: Web3MigrationRoutes.autoMigrationSignup,
		data: {
			component: Web3AutoMigrationMergeComponentComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: true,
				headerTitleKey: "web3_signup_title",
				cancelKey: "close",
				size: ModalSizes.lg,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: false
			}
		},
		canActivate: [web3VisionGuardFn]
	},
	{
		component: ModalHolderComponent,
		path: Web3MigrationRoutes.autoMigrationSuccess,
		canActivate: [migrationSuccessGuard],
		data: {
			component: Web3AutoMigrateSuccessComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: true,
				headerTitleKey: "web3_signup_success",
				cancelKey: "close",
				size: ModalSizes.lg,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: false
			}
		}
	},
	{
		component: ModalHolderComponent,
		path: "notfound",
		data: {
			component: NotFoundModalComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: true,
				size: ModalSizes.lg,
				extraClass: ["no-gutter"]
			}
		}
	},
	//TODO: Notice this redirect is only for testing, ideally the redirect should be done from the guard on the parent level. Remove this later
	{
		path: "",
		redirectTo: Web3MigrationRoutes.autoMigrationIntro,
		pathMatch: "full"
	},
	{
		path: "**",
		redirectTo: "notfound",
		pathMatch: "full"
	}
];

@NgModule({
	declarations: [],
	imports: [Web3AutoMigrationIntroComponentComponent, RouterModule.forChild(routes)],
	exports: []
})
export class Web3MigrationModule {}
